import { Stars } from '@react-three/drei'

const AmbientLight = () => (
    <>
        {/* <Sky scale={50} sunPosition={[500, 350, -1000]} turbidity={1} /> */}
        {/* <color attach="background" args={['#f0f0f0']} /> */}
        {/* <Stars /> */}
        <ambientLight intensity={1} />
        <pointLight position={[20, 30, 10]} />
        <spotLight intensity={0.5} angle={0.2} penumbra={1} position={[5, 15, 10]} />
    </>
)

export default AmbientLight